import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {MenuItem, Select} from "@mui/material";
import {SelectChangeEvent} from "@mui/material/Select/SelectInput";
import {selectTile} from "modules/actions";
import {getIsCurrentSeason, getSelectedTile, isLoggedIn} from "modules/selectors";
import {getFullFantasyEvent, getParticipatedTiles} from "modules/selectors/fantasy_tiles";
import React, {useCallback, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import styled from "styled-components";

const Wrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-left: auto;
	max-width: 120px;

	.MuiOutlinedInput-root {
		height: 24px;
		padding: 0;
		background: #ffffff;
		border-radius: 16px;

		color: var(--primary1);
		font-size: 13px;
		font-style: normal;
		font-weight: 400;
		line-height: 18px;
		letter-spacing: 0.16px;
		max-width: 120px;
	}

	svg {
		width: 24px;
		height: 24px;
		color: #00e68c;
		pointer-events: none;
		position: absolute;
		right: 4px;
	}

	.MuiSelect-select {
		padding: 0 32px 0 8px !important;

		&[aria-expanded="true"] + svg {
			transform: rotate(180deg);
		}
	}

	fieldset {
		border: none;
		border-radius: 16px;
	}
`;

const SMenuItem = styled(MenuItem)`
	text-transform: capitalize;
`;

export const SwingToggle: React.FC = () => {
	const isAuthenticated = useSelector(isLoggedIn);
	const navigate = useNavigate();
	const location = useLocation();
	const selectedTileId = useSelector(getSelectedTile)?.id;
	const dispatch = useDispatch();

	const fullFantasyTile = useSelector(getFullFantasyEvent);
	const swings = useSelector(getParticipatedTiles);
	const isLanding = location.pathname === "/";
	const isCurrentSeason = useSelector(getIsCurrentSeason);
	const isVisible = !isLanding && isAuthenticated && swings.length > 0 && isCurrentSeason;

	useEffect(() => {
		if (!isCurrentSeason) {
			dispatch(selectTile(null));
		}
	}, [dispatch, isCurrentSeason]);

	const navigateToNewSwing = useCallback(
		(swingId: number) => {
			const isFullFantasy = fullFantasyTile?.id === swingId;
			if (!swingId) {
				return;
			}

			const isLeaderboards = location.pathname.includes("/leaderboard");

			if (isLeaderboards) {
				navigate(isFullFantasy ? "/leaderboard" : `/leaderboard/swing/${swingId}`);
			}

			navigate(isFullFantasy ? "/team" : `/team/${swingId}`);
		},
		[location, navigate, fullFantasyTile]
	);

	const handleChange = useCallback(
		(event: SelectChangeEvent<string>) => {
			const value = Number(event.target.value);
			if (!value) {
				return;
			}

			dispatch(selectTile(value));
			navigateToNewSwing(value);
		},
		[navigateToNewSwing, dispatch]
	);

	if (!isVisible) {
		return null;
	}

	return (
		<Wrapper>
			<Select
				name="swings"
				value={selectedTileId ? String(selectedTileId) : "0"}
				onChange={handleChange}
				IconComponent={() => <KeyboardArrowDownIcon />}>
				<MenuItem value="0" disabled>
					Select Swing
				</MenuItem>
				{swings.map((swing) => (
					<SMenuItem key={swing.id} value={String(swing.id)}>
						{swing.name}
					</SMenuItem>
				))}
			</Select>
		</Wrapper>
	);
};
